import "./ActionFootage.module.css";
import Header from "@/reusable_sections/Header";
import TheMulchingVault from "./sections/TheMulchingVault";
import Footer from "@/reusable_sections/Footer";
export default function ActionFootagePage() {
  return <div>
      <Header />
      <TheMulchingVault />
      <Footer />
    </div>;
}